import { render, staticRenderFns } from "./JoinTeamCard.vue?vue&type=template&id=7d6c07ad&v-loading=loading"
import script from "./JoinTeamCard.vue?vue&type=script&lang=ts"
export * from "./JoinTeamCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_op2felhwcemqlmdmuodyzlbaea/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports